// https://github.com/xigua1994/react-tiga-swiper/blob/master/README.zh-cn.md
import React, { Component, useRef, useState } from 'react'

import Swiper from 'react-tiga-swiper'
import 'react-tiga-swiper/dist/index.css'
import "./index.css";
import classNames from 'classnames'
import { BsyUtils } from "../../../utils/Utils";
import BsyDashBase from "../BsyDashBase";


// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component

/**
 * 
 */
class BsyDashImageMore extends BsyDashBase {
    constructor(props) {
        super(props);
        this.state = {
            _imageModel: this.props.imageListModel,
            autoPlay: Number | Boolean,
            width: '100%',
            showContent: false
        };
        this.swiperRef = React.createRef();
        this.noreferrer = React.createRef();
    }

    componentDidMount() {
        //不清楚为啥要加上才能显示带数据图标
        if (this.props.getContext) {
            this.props.getContext(this);
        }

        //没时间查看渲染框架，拿不到真实宽度
        setTimeout(() => {
            var ret = BsyUtils.closestClass(this.noreferrer.current, 'react-grid-item');
            if (ret) {
                console.log(ret.style.width)
                this.setState({
                    width: ret.style.width,
                })
            }
            this.setState({
                showContent: true
            })

        }, 100);

        //插件bug，loop无效，后续修改
        if (this.state._imageModel.automaticWheelSeeding) {
            var d = this.state._imageModel.intervalBetweenRotations
            this.setState({
                autoPlay: d
            })
        } else {
            this.setState({
                autoPlay: 999999
            })
        }
    }
    openImage = (val, item, key) => {
        const { appId, entryId } = this.props;
        console.log(item)
        if (item.hyperlink && item.hyperlink !== "") {
            BsyUtils.redirectTo(item.hyperlink, "_blank")
        } else {
            new window.FX.FilePreview({
                widgetType: "image",
                files: this.state._imageModel.files,
                appId: appId,
                formId: entryId,
                currentItem: key,
            });
        }
    };
    loadData = (n, d) => {
        BsyUtils.applyFunc(this, this.props.onLoadSuccess, [{}, n, d], !1);
    };
    render() {

        return <div ref={this.noreferrer} style={{ 'height': '100%', 'width': this.setState.width }}>
            {
                this.state.showContent && <Swiper
                    autoPlay={this.state.autoPlay * 1000}
                    selectedIndex={0}
                    className='image-more-list'
                    showIndicators={this.state._imageModel.files.length > 1}
                    showDots={this.state._imageModel.files.length > 1}
                    dots={null}
                    ref={this.swiperRef}
                >
                    {this.state._imageModel.files.map((item, key) => {
                        const url = BsyUtils.getfiledownloadURL(item, {});
                        return (
                            <div className="t-a-href" rel={this.noreferrer} key={key}>
                                <div className={classNames('pic', this.state._imageModel.fillingMode)}
                                    style={{
                                        "backgroundImage": url ? "url(" + url + ")" : "",
                                    }}
                                    onClick={(val) => { this.openImage(val, item, key) }}>
                                    <div className={classNames('display-copy', item.displayCopy && item.displayCopy !== "" ? 'has-bg' : null)}>{item.displayCopy ? item.displayCopy : ''}</div>
                                </div>
                            </div>
                        )
                    })}

                </Swiper>
            }
        </div>
    }
}

export default BsyDashImageMore;